import React, { useState, useRef, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Radio from "@mui/material/Radio";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";

// demo image
import PillowImg from "../../assets/page icons/pillowAddon.png";

export default function AddonsOffCanvas({ isOpen, onClose }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const BASE_PRICE = 44480;

  const [addon, setAddon] = useState({
    selected: false,
    type: "single",
    price: 400,
  });

  const toggleAddon = () => {
    setAddon((prev) => ({ ...prev, selected: !prev.selected }));
  };

  const totalPrice = addon.selected ? BASE_PRICE + addon.price : BASE_PRICE;
  const itemCount = addon.selected ? 2 : 1;
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // cleanup (important)
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-[#113b1880] backdrop-blur-sm z-40"
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 z-50 h-full w-full
        md:w-full lg:w-[70%] xl:w-[50%] 2xl:w-[45%]
        bg-white transition-transform duration-300 ease-in-out
        ${isOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        {/* Header */}
        <div className="flex justify-end py-6 px-6 md:py-8 md:px-8">
          <button
            onClick={onClose}
            className="w-6 h-6 flex items-center justify-center rounded-full border border-[#29562f] text-[#29562f]"
          >
            <CloseIcon sx={{ fontSize: 16 }} />
          </button>
        </div>

        {/* CONTENT */}
        <div className="pb-80 sm:pb-60 px-5 md:px-10 3xl:px-20 overflow-y-auto h-full lg:pb-0">
          {/* Title */}
          <div className="pb-10 md:pb-14">
            <h2 className="text-[26px] md:text-[32px] xl:text-[42px] 3xl:text-[52px] font-calsans leading-tight">
              Complete Your <br /> Sleep Experience
            </h2>
            <p className="text-[#5f5f5f] text-[16px] md:text-[18px] 3xl:text-[20px] font-lexend mt-2 font-light">
              Add these essentials & create the ultimate Moondew sleep
              experience.
            </p>
          </div>

          {/* ADD-ON CARD */}
          <div
            onClick={toggleAddon}
            className={`relative flex flex-col md:flex-row gap-6 md:gap-8 p-6 md:p-8 rounded-lg cursor-pointer transition-all
            ${addon.selected ? "border-2 border-[#29562f]" : "border-2 border-[#dcdcdc]"}`}
          >
            {/* RADIO */}
            <div
              className="absolute top-4 right-4"
              onClick={(e) => e.stopPropagation()}
            >
              <Radio
                checked={addon.selected}
                onClick={(e) => {
                  e.stopPropagation();
                  setAddon((prev) => ({
                    ...prev,
                    selected: !prev.selected,
                  }));
                }}
                sx={{
                  color: "#29562f",
                  "&.Mui-checked": { color: "#29562f" },
                }}
              />
            </div>

            {/* Image */}
            <img
              src={PillowImg}
              alt="Latex Pillow"
              className="mx-auto md:mx-0 xs:w-[100px] xs:h-[100px]  sm:w-[140px] sm:h-[140px] md:w-[180px] md:h-[180px] 3xl:w-[230px] 3xl:h-[230px] object-cover"
            />

            {/* Content */}
            <div className="flex-1 text-center md:text-left">
              <h3 className="font-semibold text-[20px] md:text-[22px] 3xl:text-[26px] font-lexend text-[#333]">
                Standard organic Latex Pillow
              </h3>

              <p className="text-[#5f5f5f] text-[16px] md:text-[18px] 3xl:text-[20px] font-lexend mt-1">
                Made from 100% natural latex for optimal head and neck
                alignment.
              </p>

              {/* PRICE DROPDOWN */}
              <div
                ref={dropdownRef}
                className="relative mt-4 w-fit mx-auto md:mx-0"
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  onClick={() => setOpen(!open)}
                  className="border border-[#b1b1b1] rounded-lg px-4 py-3 flex items-center gap-4 cursor-pointer bg-white"
                >
                  <p className="text-[16px] md:text-[18px] text-[#333] font-lexend">
                    <span className="font-semibold capitalize">
                      {addon.type}
                    </span>{" "}
                    <span className="font-semibold">₹{addon.price}</span>
                  </p>
                  <ExpandMoreIcon
                    sx={{ fontSize: 26 }}
                    className={`text-[#afafaf] transition-transform ${
                      open ? "rotate-180" : ""
                    }`}
                  />
                </div>

                {open && (
                  <div className="absolute z-10 mt-2 w-full bg-white border border-[#b1b1b1] rounded-lg shadow-md overflow-hidden font-lexend">
                    <div
                      onClick={() => {
                        setAddon({ ...addon, type: "single", price: 400 });
                        setOpen(false);
                      }}
                      className="px-4 py-3 cursor-pointer hover:bg-[#f5f5f5]"
                    >
                      <span className="font-semibold">Single</span> ₹400
                    </div>
                    <div
                      onClick={() => {
                        setAddon({ ...addon, type: "double", price: 700 });
                        setOpen(false);
                      }}
                      className="px-4 py-3 cursor-pointer hover:bg-[#f5f5f5]"
                    >
                      <span className="font-semibold">Double</span> ₹700
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Sticky Bottom Bar */}
        <div className="absolute bottom-0 left-0 right-0 bg-[#f6eb9a] py-4 md:py-6 px-5 md:px-20 flex flex-col md:flex-row gap-4 md:gap-0 justify-between items-center">
          <div className="flex items-end gap-3">
            <p className="text-[24px] md:text-[32px] 3xl:text-[40px] font-calsans text-[#2f5d3a]">
              ₹{totalPrice.toLocaleString()}
            </p>
            <p className="text-[16px] md:text-[20px] pb-2 font-lexend text-[#2f5d3a]">
              {itemCount} item{itemCount > 1 && "s"}
            </p>
          </div>

          <Link
            to="/checkout"
            className="flex items-center gap-3 bg-[#2f5d3a] text-[#f6eb9a] sm:text-[16px] text-[22px] px-6 font-bold py-3 rounded-md hover:bg-[#264e31] w-full md:w-auto justify-center"
          >
            <ShoppingCartIcon />
            Proceed to buy
          </Link>
        </div>
      </div>
    </>
  );
}
